export default "__VITE_PUBLIC_ASSET__440a9bf0__"